var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutubeDesktopShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M12.5 0a2.5 2.5 0 1 1-1.674 4.357l-5.907 2.51a2.5 2.5 0 0 1 .05 1.029l5.71 2.891a2.5 2.5 0 1 1-.666 1.457l-5.79-2.932a2.5 2.5 0 1 1-.208-3.8l6.026-2.561A2.5 2.5 0 0 1 12.5 0"
})));
export default SvgYoutubeDesktopShare;